import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'smt-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
})
export class InputComponent implements OnInit, OnChanges {
  @Output() change = new EventEmitter<void>();
  @Output() input = new EventEmitter<void>();
  @Input() group: FormGroup<any>;
  @Input() controlName: string;
  @Input() label: string;
  @Input() readonly: boolean;
  @Input() textarea: boolean;
  @Input() maxlength: number;
  @Input() minlength: number;
  @Input() type: string;
  @Input() min: number;
  @Input() max: number;
  @Input() step: number;
  @Input() hint: string;
  @Input() disabled: boolean;

  constructor() {
    this.readonly = false;
    this.textarea = false;
  }

  ngOnInit(): void {
    this.textarea = this.type === "textarea" ? true : this.textarea;

    if (this.disabled === undefined) {
      this.disabled = this.group?.disabled || this.control?.disabled ? true : this.disabled;
    }

    this.disable(this.disabled);
  }

  ngOnChanges(changes: SimpleChanges): void {
    const disabledChange = changes["disabled"];
    if (disabledChange !== undefined) {
      this.disable(disabledChange.currentValue);
    }
  }

  disable(disable: boolean) {
    const control = this.group?.controls[this.controlName];
    disable ? control?.disable() : control?.enable();
  }

  get control(): AbstractControl<any, any> {
    return this.group.get(this.controlName);
  }
}
